import styled from 'styled-components'

import {
  PRIMARY_NORMAL_COLOR, GREY_NORMAL_COLOR,
} from '@CSSVars/colors'


export const _Container = styled.div`
  position: relative;

  input {
    border: none !important;
    padding: 15px;
  }

  ul {
    list-style-type: none !important;
    padding: 0 !important;
    margin: 0;
  }

  .react-autosuggest__suggestions-container {
    z-index: 1000;
  }

  .react-autosuggest__suggestion--highlighted > div {
    & > div {
      &:nth-child(2) {
        opacity: 0.2;
      }
    }
  }

  .ais-InstantSearch__root{
    width: 100%;
  }
`

export const _Divider = styled.div`
  position: relative;
  padding: 1rem;
  background-color: white;
  text-align: left;
  color: ${PRIMARY_NORMAL_COLOR};
  border-top: 1px solid ${GREY_NORMAL_COLOR};
`

export const _SpinnerContainer = styled.div`
  position: absolute;
  right: 15px;
  top: ${({ fromHome }) => (fromHome ? '10px' : '15px')};
  display: flex;
  align-items: flex-start;

  @media screen and (max-width: 63.9em) {
    right: ${({ fromHome }) => (fromHome ? '10px' : '30px')};
  }
`
